// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import DashboardLayout from "../components/DashboardLayout";
// import "../styles/DispatchHistory.css";


// const API_BASE = process.env.REACT_APP_API_BASE;
// const DispatchHistory = () => {
//   const [logs, setLogs] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [userEmail, setUserEmail] = useState("");
//   const [swipedId, setSwipedId] = useState(null);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const email = localStorage.getItem("userEmail");
//     setUserEmail(email);

//     if (!email) {
//       setLoading(false);
//       return;
//     }


//     fetch(`${API_BASE}/api/dispatch-log?email=${email}`)
//       .then((res) => res.json())
//       .then((data) => {
//         if (data.success) setLogs(data.logs);
//         setLoading(false);
//       })
//       .catch(() => setLoading(false));
//   }, []);

//   const totalAmount = logs.reduce((sum, log) => sum + (log.amount || 0), 0);

//   const handleSwipe = (id) => {
//     setSwipedId(swipedId === id ? null : id);
//   };

//   const handleView = (log) => {
//     alert(`Viewing dispatch for ${log.files.join(", ")}`);
//   };

//   const handleDelete = (id) => {
//     alert(`Deleting dispatch with id: ${id}`);
//   };

//   // 🔑 Navigation handlers
//   const goToDashboard = () => navigate("/dashboard");
//   const goToSendCheck = () => navigate("/create");
//   const goToSendDocument = () => navigate("/dashboard");
//   const goToPricing = () => navigate("/pricing");

//   return (
//     <DashboardLayout>
//       <div className="dispatch-history-container">

//         {/* 👋 Welcome Section */}
//         <div className="welcome-hero">
//           <h1>👋 Welcome back{userEmail ? `, ${userEmail}` : ""}!</h1>
//           <p>Here’s a quick look at your dispatch journey with us.</p>
//         </div>

//         {/* 📊 Quick Stats */}
//         <div className="stats-cards">
//           <div className="stat-card">
//             <h3>{logs.length}</h3>
//             <p>Total Dispatches</p>
//           </div>
//           <div className="stat-card">
//             <h3>${totalAmount.toFixed(2)}</h3>
//             <p>Total Spent</p>
//           </div>
//           {logs.length > 0 && (
//             <div className="stat-card">
//               <h3>{new Date(logs[0].timestamp).toLocaleDateString()}</h3>
//               <p>Last Dispatch</p>
//             </div>
//           )}
//         </div>

//         {/* 📦 Dispatch History List */}
//         <h2 className="history-title">📦 My Dispatch History</h2>
//         {loading ? (
//           <p>Loading...</p>
//         ) : logs.length === 0 ? (
//           <div className="empty-state">
//             <p>No dispatches yet 🚀</p>
//             {/* <button className="cta-button" onClick={goToSendDocument}>
//               ➕ Create Your First Dispatch
//             </button> */}
//             <button className="cta-button" onClick={goToDashboard}>
//   ➕ Create Your First Dispatch
// </button>

//           </div>
//         ) : (
//           <ul className="dispatch-log-list">
//             {logs.map((log, index) => (
//               <li
//                 key={index}
//                 className={`dispatch-log-wrapper ${swipedId === index ? "swiped" : ""}`}
//                 onClick={() => handleSwipe(index)}
//               >
//                 <div className="dispatch-log-item">
//                   <div className="log-header">
//                     <span className="log-type">
//                       {log.files.some(f => f.includes("check")) ? "🧾 Check" : "📑 Document"}
//                     </span>
//                     <span className="log-amount">${log.amount}</span>
//                   </div>
//                   <p><strong>Files:</strong> {log.files.join(", ")}</p>
//                   <p><strong>Sent:</strong> {new Date(log.timestamp).toLocaleString()}</p>
//                   {log.address && (
//                     <p><strong>To:</strong> {log.address.line1}, {log.address.city}, {log.address.state}</p>
//                   )}
//                 </div>
//                 <div className="dispatch-log-actions">
//                   <button onClick={() => handleView(log)}>View</button>
//                   <button onClick={() => handleDelete(index)}>Delete</button>
//                 </div>
//               </li>
//             ))}
//           </ul>
//         )}

//         {/* 💡 Next Actions */}
//         <div className="next-actions">
//           <h3>✨ What would you like to do next?</h3>
//           <div className="actions-buttons">
//             <button onClick={goToSendCheck}>✉️ Send a Check</button>
//             <button onClick={goToSendDocument}>📑 Upload a Document</button>
//             <button onClick={goToPricing}>💵 View Pricing</button>
//           </div>
//         </div>

//       </div>
//     </DashboardLayout>
//   );
// };

// export default DispatchHistory;






// src/pages/DispatchHistory.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "../components/DashboardLayout";
import "../styles/DispatchHistory.css";
import api from "../api/apiClient";


const API_BASE = process.env.REACT_APP_API_BASE;

const DispatchHistory = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [userEmail, setUserEmail] = useState("");
  const [userName, setUserName] = useState("");
  const navigate = useNavigate();


  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
    const email = localStorage.getItem("userEmail") || storedUser?.email || "";
    const name = storedUser?.name || "";

    setUserName(name);
    setUserEmail(email);


  }, []);


  useEffect(() => {
    const email = localStorage.getItem("userEmail");
    setUserEmail(email);
    if (!email) {
      setLoading(false);
      return;
    }

    const fetchLogs = async () => {
      try {
        // ✅ Use apiClient (it automatically includes Authorization header)
        const { data } = await api.get(`/api/dispatch-log?email=${email}`);

        if (data.success && Array.isArray(data.logs)) {
          setLogs(data.logs);
        } else {
          console.warn("⚠️ Unexpected data format:", data);
        }
      } catch (err) {
        console.error("❌ Failed to fetch dispatch logs:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchLogs();
  }, []);

  // 💱 Currency-aware total in USD
  const usdToNgnRate = 1600; // temporary static rate; replace with live API later

  const totalUSD = logs.reduce((sum, log) => {
    const amount = log.amount || 0;
    if (log.currency === "NGN") {
      return sum + amount / usdToNgnRate; // convert NGN → USD
    } else if (log.currency === "USD") {
      return sum + amount;
    } else {
      return sum; // ignore other/unset currencies
    }
  }, 0);
  const handleView = (log) => {
    navigate("/dispatch-detail", { state: { log } });
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this dispatch?")) return;

    try {
      const { data } = await api.delete(`/api/dispatch-log/${id}`);

      if (data.success) {
        setLogs((prev) => prev.filter((l) => l._id !== id));
      } else {
        alert("Failed to delete dispatch.");
      }
    } catch (err) {
      console.error("❌ Delete failed:", err);
      alert("Network error during delete.");
    }
  };

  const goToDashboard = () => navigate("/dashboard");
  const goToSendCheck = () => navigate("/create");
  const goToSendDocument = () => navigate("/dashboard");
  const goToPricing = () => navigate("/pricing");

  return (
    <DashboardLayout>
      <div className="dispatch-history-container">
        {/* 👋 Welcome Section */}
        <div className="welcome-hero">
          <h1>
            👋 Welcome back
            {userName
              ? `, ${userName}`
              : userEmail
                ? `, ${userEmail}`
                : ""}!
          </h1>
          <p>Here's a quick look at your dispatch journey.</p>
        </div>

        {/* 📊 Quick Stats */}
        <div className="stats-cards">
          <div className="stat-card">
            <h3>{logs.length}</h3>
            <p>Total Dispatches</p>
          </div>
          <div className="stat-card">
            <h3>${totalUSD.toFixed(2)}</h3>
            <p>Total Spent </p>
          </div>
          {logs.length > 0 && (
            <div className="stat-card">
              <h3>
                {new Date(
                  logs[0]?.mailDate || logs[0]?.createdAt || Date.now()
                ).toLocaleDateString()}
              </h3>
              <p>Last Dispatch</p>
            </div>
          )}
        </div>

        {/* 📦 Dispatch History */}
        <h2 className="history-title">📦 My Dispatch History</h2>
        {loading ? (
          <p>Loading your dispatches...</p>
        ) : logs.length === 0 ? (
          <div className="empty-state">
            <p>No dispatches yet 🚀</p>
            <button className="cta-button" onClick={goToDashboard}>
              ➕ Create Your First Dispatch
            </button>
          </div>
        ) : (
          <ul className="dispatch-log-list">
            {logs.map((log, index) => {
              const fileNames =
                Array.isArray(log.files) && log.files.length
                  ? log.files.map((f) => f.name).join(", ")
                  : "No files recorded";

              const date = new Date(
                log.mailDate || log.createdAt || Date.now()
              ).toLocaleString();

              return (
                <li key={log._id || index} className="dispatch-log-item">
                  <div className="log-header">
                    <span className="log-type">
                      {fileNames.toLowerCase().includes("check")
                        ? "🧾 Check"
                        : "📑 Document"}
                    </span>
                    <span className="log-amount">
                      {log.currency === "NGN" ? "₦" : "$"}{log.amount || 0}
                    </span>
                  </div>

                  <p>
                    <strong>Files:</strong> {fileNames}
                  </p>
                  {log.address && (
                    <p>
                      <strong>To:</strong>{" "}
                      {`${log.address.address_line1 || log.address.line1 || ""}, ${log.address.city_locality || log.address.city || ""
                        }, ${log.address.state_province || log.address.state || ""}`}
                    </p>
                  )}
                  <p>
                    <strong>Date:</strong> {date}
                  </p>
                  {log.carrierTrackingNumber && (
                    <p>
                      <strong>Tracking:</strong>{" "}
                      <a
                        href={log.carrierTrackingUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {log.carrierTrackingNumber}
                      </a>
                    </p>
                  )}
                  {log.cjetTrackingId && (
                    <p>
                      <strong>CJet ID:</strong> {log.cjetTrackingId}
                    </p>
                  )}

                  <div className="dispatch-log-actions">
                    <button onClick={() => handleView(log)}>View</button>
                    <button onClick={() => handleDelete(log._id)}>Delete</button>
                  </div>
                </li>
              );
            })}
          </ul>
        )}

        {/* 💡 Next Actions */}
        <div className="next-actions">
          <h3>✨ What would you like to do next?</h3>
          <div className="actions-buttons">
            <button onClick={goToSendCheck}>✉️ Send a Check</button>
            <button onClick={goToSendDocument}>📑 Upload a Document</button>
            <button onClick={goToPricing}>💵 View Pricing</button>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default DispatchHistory;